export default __webpack_public_path__ + "static/QCon_SF_2024-89985859439fc24010d0d1e9e12cd806.png";